import axios from "axios";

axios.defaults.baseURL = "https://swantonpoppy.org/";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
